<template>
  <div>
    <van-cell class="ry-form__digital" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{showValue}}{{current.showUnit}}
        </div>
        <van-field
          :class="{'btn' : current.triggerType === TRIGGER_TYPE_BUTTON}"
          v-if="!isRead"
          type="number"
          :readonly="isReadOnly"
          @blur="inputBlur"
          @focus="inputFocus"
          @change="valueChange"
          v-model="content"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
          <div slot="extra" style="display: flex">
            <div style="display: flex; align-items: center; margin-right: 10px">{{current.showUnit}}</div>
            <van-button
              v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
              size="small"
              style="color: #ffffff;"
              :loading="loading"
              :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
              @click="onClickBtn"
              type="primary">
              {{current.buttonName}}
            </van-button>
          </div>
        </van-field>

      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__digital-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{showValue}}{{current.showUnit}}
          </div>
        </template>
      </van-field>

      <van-field
        :class="{'btn' : current.triggerType === TRIGGER_TYPE_BUTTON}"
        v-if="!isRead"
        type="number"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly"
        @blur="inputBlur"
        @focus="inputFocus"
        @change="valueChange"
        v-model="content"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : current.fieldDes"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <div slot="extra" style="display: flex">
          <div style="display: flex; align-items: center; margin-right: 10px">{{current.showUnit}}</div>
          <van-button
            v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
            size="small"
            style="color: #ffffff;"
            :loading="loading"
            :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
            @click="onClickBtn"
            type="primary">
            {{current.buttonName}}
          </van-button>
        </div>
      </van-field>
    </div>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>
</template>

<script>
  import {current} from './mixin'
  import {TRIGGER_TYPE_BLUR, TRIGGER_TYPE_FOCUS, TRIGGER_TYPE_BUTTON} from "../types";
  import {formatNum} from "../../../assets/js/Untis";

  export default {
    mixins: [current],
    data() {
      return {
        TRIGGER_TYPE_BUTTON,
        isError: false,
        oldValue: 0
      }
    },
    created() {
      this.oldValue = this.current.value
    },
    computed: {
      content: {
        set(newVal) {
          if (newVal) {
            if (this.current.checkCondition.numLimit) {
              if (newVal < this.current.checkCondition.minNum) {
                this.$toast.fail(`输入值不能小于${this.current.checkCondition.minNum}`)
                return
              } else if (newVal > this.current.checkCondition.maxNum) {
                this.$toast.fail(`输入值不能大于${this.current.checkCondition.maxNum}`)
                return
              }
            }
            if (this.current.checkCondition.integerOnly) {
              // 只能是整数
              if (newVal.includes('.')) {
                this.$toast.fail(`输入值不能是小数`)
                return
              }
            } else {
              // 可以有小数
              if (this.current.checkCondition.decimalLimit) {
                // 开启小数位数验证
                if (newVal.toString().split(".")[1] &&
                  newVal.toString().split(".")[1].length > this.current.checkCondition.decimalCount) {
                  this.$toast.fail(`输入值小数位数不能大于${this.current.checkCondition.decimalCount}位`)
                  return
                }
              }
            }
          }
          this.current.value = newVal
            .replace(/[^\-?\d.]/g, "")
          // .replace(/[^\d.]/g, "")   // 清除“数字”和“.”以外的字符
          // .replace(/^\./g, "")      // 验证第一个字符是数字而不是.
          // .replace(".", "$#$")
          // .replace(/\./g, "")
          // .replace("$#$", ".")
        },
        get() {
          return this.current.value
        }
      },
      checkList() {
        return this.current.checkList()
      },
      errorMessage() {
        return this.isError ? this.current.requiredShowText : ''
      },
      showValue() {
        if (this.current.tp === 'YES') {
          return formatNum(this.current.value)
        } else {
          return this.current.value
        }
      }
    },
    methods: {
      onClickBtn() {
        console.log('onClickBtn', this.current.pluginConfig)
        if (this.current.showAlert) {
          this.$dialog.confirm({
            title: '确认信息',
            message: this.current.alertText,
          })
            .then(() => {
              // on confirm
              this.submitData()
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.submitData()
        }
      },

      // Input 失去焦点时触发
      inputBlur() {

        if (!this.current.value) {
          this.current.value = 0
        }
        // this.current.value = Number(this.current.value)
        this.isError = this.current.checkMissValue && !isNaN(this.current.value)
        console.log(this.oldValue, this.current.value)
        if (this.current.triggerType === TRIGGER_TYPE_BLUR && this.oldValue !== this.current.value) {
          this.submitData()
        }
        this.oldValue = this.current.value
        console.log(this.current.value)
      },

      // Input 获得焦点时触发
      inputFocus() {
        if (!this.current.value || !Number(this.current.value)) {
          this.current.value = null
        }
        if (this.current.triggerType === TRIGGER_TYPE_FOCUS) {
          this.submitData()
        }
      },
      valueChange() {
        // this.current.value = Number(this.current.value)
        this.controlChange()
      }
    }
  }
</script>

<style lang="less">

  .ry-form__digital {

    .btn {
      padding: 0 !important;

      .van-field__body {
        margin-right: 0 !important;

        .van-field__button {
          height: auto;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>
